// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KpiCards_grid__P3uSf {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
/* Proporcional: 4 -> 2,2 -> 1,1,1,1 (nunca 3 para no dejar huecos) */
@media (max-width: 1480px) {
  .KpiCards_grid__P3uSf {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 620px) {
  /* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): ver la nota del mismo cambio en \`Dashboard.module.css\`. */
  .KpiCards_grid__P3uSf {
    grid-template-columns: minmax(0, 1fr);
  }
}

.KpiCards_card__J0atp {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--kpi-border, var(--dylo-surface-border));
  border-radius: 14px;
  box-shadow: var(--shadow-card);
  padding: 16px 18px;
}

.KpiCards_iconBox__8PcIx {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  color: #fff;
  flex-shrink: 0;
}

.KpiCards_body__IGEcz {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.KpiCards_label__J5bNN {
  font-size: 14px;
  font-weight: 500;
  color: var(--dylo-text);
  line-height: 1.25;
}

.KpiCards_sep__lQ4rp {
  color: var(--dylo-line);
}

.KpiCards_value__WJO43 {
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/KpiCards.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA,qEAAqE;AACrE;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE,uGAAuG;EACvG;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,yFAAyF;EACzF,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n/* Proporcional: 4 -> 2,2 -> 1,1,1,1 (nunca 3 para no dejar huecos) */\n@media (max-width: 1480px) {\n  .grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 620px) {\n  /* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): ver la nota del mismo cambio en `Dashboard.module.css`. */\n  .grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--kpi-border, var(--dylo-surface-border));\n  border-radius: 14px;\n  box-shadow: var(--shadow-card);\n  padding: 16px 18px;\n}\n\n.iconBox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.body {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--dylo-text);\n  line-height: 1.25;\n}\n\n.sep {\n  color: var(--dylo-line);\n}\n\n.value {\n  font-size: 20px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `KpiCards_grid__P3uSf`,
	"card": `KpiCards_card__J0atp`,
	"iconBox": `KpiCards_iconBox__8PcIx`,
	"body": `KpiCards_body__IGEcz`,
	"label": `KpiCards_label__J5bNN`,
	"sep": `KpiCards_sep__lQ4rp`,
	"value": `KpiCards_value__WJO43`
};
export default ___CSS_LOADER_EXPORT___;
